module.exports = __webpack_public_path__ + "f6d4ccb185d2c01a4cc12ff731c0a53c.pdf";